import React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const ColoredSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase': {
      '&.MuiSwitch-track': {
        color: '#4caf50', 
        '& + .MuiSwitch-track': {
          backgroundColor: '#4caf50',
        },
      },
      '&.Mui-checked.Mui-disabled': {
        color: '#a5d6a7',
        '& + .MuiSwitch-track': {
          backgroundColor: '#a5d6a7',
        },
      },
    },
    '& .MuiSwitch-track': {
      backgroundColor: '#f44336',
    },
  }));

function ApprovalToggle({ item, index, approveHandler }) {
  return (
    <FormControlLabel
      control={
        <ColoredSwitch
          checked={item.isApproved === true}
          onChange={(e) => approveHandler(item, e.target.checked, index)}
        />
      }
      label={item.isApproved ? "Approved" : "Rejected"}
    />
  );
}

export default ApprovalToggle;
